// src/i18n.js
import { createI18n } from 'vue-i18n'

// Definisi teks 2 bahasa
const messages = {
  id: {
    menuProfile: {
        mainmenu: 'Profil',
        submenu1: 'Sejarah',
        submenu2: 'Manajemen',
        submenu3: 'Struktur',
        submenu4: 'Penghargaan'
      },
      menuTatakelola: {
        mainmenu: 'Tata Kelola',
        submenu1: 'Pedoman Tata Kelola',
        submenu2: 'Charter'
      },
      menuProduklayanan: {
        mainmenu: 'Produk & Layanan',
        submenu1: 'Produk',
        submenu2: 'Layanan',
        submenu3: 'Anak Perusahaan',
        subsubmenu1: 'Investasi Energi & Utilitas Strategis',
        subsubmenu2: 'Operasi & Pemeliharaan',
        subsubmenu3: 'Perdagangan Energi Primer',
        subsubmenu4: 'Kemitraan Pengembangan Proyek',
        subsubmenu5: 'Layanan Portfolio Energi Terbarukan'
      },
      menuLaporan: {
        mainmenu: 'Laporan',
        submenu1: 'Laporan Tahunan',
        submenu2: 'Laporan Keuangan',
        submenu3: 'Laporan Keberlanjutan'
      },
      menuBerita: {
        mainmenu: 'Berita',
        submenu1: 'Artikel',
        submenu2: 'Siaran Pers',
        submenu3: 'Bulletin Buzz',
        moreArticles: 'Artikel Lainnya',
        morePress: 'Siaran Pers Lainnya',
        readMore: 'Baca selengkapnya'
      },
      menuKeberlanjutan: {
        mainmenu: 'Keberlanjutan'
      },
      menuKontak: {
        mainmenu: 'Kontak Kami'
      },
      pageKontak: {
        title:  'Kontak Kami',
        heading: 'Kantor Pusat',
        subtitle: 'Suara anda sangat berarti untuk kami. Kirimkan kami pesan menggunakan form berikut atau melalui kontak dibawah ini.',
        field1: 'Nama Lengkap',
        field2: 'Nomor Telepon',
        field3: 'E-Mail',
        field4: 'Pesan'
      },


    companyPillars: {
      subtitle:
        'Dalam menciptakan fondasi yang kokoh dan berkelanjutan bagi kesuksesan PT Pupuk Indonesia Utilitas',
      vision:
        'Menjadi Perusahaan Energi dan Utilitas terintegrasi kelas dunia untuk menunjang bisnis utama PT Pupuk Indonesia (Persero) beserta anak perusahaannya.',
      visionTitle: 'Visi',
      missionTitle: 'Misi',
      mission: {
        item1: 'Melakukan usaha dalam bidang penyediaan energi dan utilitas.',
        item2: 'Memberikan nilai tambah bagi stakeholders.',
        item3:
          'Mengutamakan keselamatan dan kesehatan kerja serta menjaga pelestarian lingkungan hidup dalam setiap kegiatan operasional.',
        item4: 'Memberikan kontribusi terhadap ketahanan energi nasional.'
      },
      businessLine: {
        title1: 'Penyediaan Listrik dan Steam',
        title2: 'Penyediaan Air Industri dan Demin',
        title3: 'Gas Industri',
        title4: 'Operation and Maintenance (O&M)',
        title5: 'Penyediaan Solusi Utilitas Lainnya',
        title5sub:
          'Integrasi Listrik, Shore to Ship Connection, PLTS, SPKLU, dll'
      },
      businessEnabler: {
        card1: 'Business Development',
        card2: 'Supply Chain',
        card3: 'Operasional Efficiency',
        card4: 'Sistem IT'
      }
    },

    businessProfile: {
      title: 'Portofolio Bisnis Perusahaan',
      subtitle:
        'PT Pupuk Indonesia Utilitas memiliki aset fasilitas produksi di 2 (dua) lokasi, yaitu:',
      fasilitas: {
        item1:
          'Gresik Gas Cogeneration Plant di Gresik : GTG 22 MW, HRSG 60 tph, PB 100 tph',
        item2:
          'Cogeneration Plant di Bontang, melalui subsidiary PT Kaltim Daya Mandiri (KDM) : GTG 34 MW, HRSG 156 tph, N2 Plant 500 Nm3/h, SWRO 2x50 m3/h, dan jaringan integrasi listrik. Melalui anak perusahaannya yaitu PT Kaltim Daya Mandiri Agro Energy (KDM-AE), KDM melakukan pengembangan lini bisnis pada bidang trading batubara. Sampai dengan tahun 2019 KDM-AE sudah melakukan pengiriman batubara hingga 270.000 MT/year ke wilayah Kalimantan Timur dan Sulawesi Barat.'
      }
    },

    tataKelolah: {
      title:
        'Komitmen PT Pupuk Indonesia Utilitas Penerapan Tata Kelola Perusahaan yang Baik (Good Corporate Governance)',
      subtitle:
        'Dalam rangka mewujudkan tujuan perusahaan menjadi penyedia solusi bagi sektor agro industri nasional, dengan ini Direksi dan Dewan Komisaris PT Pupuk Indonesia Utilitas, berkomitmen:',
      items: [
        'Melaksanakan setiap transaksional dan pengambilan keputusan berdasarkan prinsip-prinsip Good Corporate Governance (GCG) dan kepatuhan terhadap peraturan perundangan yang berlaku.',
        'Melaksanakan tugas dan tanggungjawab sesuai dengan Pedoman Good Corporate Governance, Board Policy Manual, Pedoman Etika Bisnis & Etika Kerja dan pedoman pendukung lainnya yang terkait dengan penerapan GCG secara konsisten dan penuh tanggung jawab.',
        'Melaksanakan pedoman lainnya terkait penerapan GCG bagi seluruh Insan PI Utilitas agar tercipta lingkungan kerja yang beretika dan bermartabat.',
        'Menerapkan laporan Manajemen dan Laporan Keuangan perusahaan yang disajikan secara transparan, akurat dan tepat waktu, serta memastikan terpenuhinya kewajiban transparasi lainnya sesuai dengan peraturan perundang-undangan yang berlaku.',
        'Memberikan keteladanan dalam semua hal dan menciptakan lingkungan kondusif dalam rangka pelaksanaan PI Utilitas bersih terhadap praktik Korupsi, Kolusi dan Nepotisme serta praktik kecurangan (Fraud) dan praktik pelanggaran hukum lainnya dengan menerapkan sanksi yang tegas untuk setiap pelanggaran.'
      ],
      closing:
        'Komitmen Direksi dan Dewan Komisaris dalam penerapan Tata Kelola Perusahaan yang Baik (Good Corporate Governance), dilaksanakan dalam Pedoman Penerapan Tata Kelola Perusahaan yang Baik (Pedoman GCG) sebagaimana terlampir:',
      documents: {
        card1: {
          title: 'Pedoman GCG',
          description:
            'Tata Kelola Perusahaan berisi Arahan Strategis Direksi dan Dewan Komisaris dalam Penerapan GCG di Perusahaan dan menjadi induk kebijakan perusahaan  yang menjadi acuan bagi seluruh kegiatan PT Pupuk Indonesia Utilitas meliputi Hubungan antara Perusahaan dengan Pemegang Saham, Fungsi serta peran Dewan Komisaris dan Direksi, Hubungan Perusahaan dengan pemangku kepentingan (Stakeholder) dan prinsip-prinsip mengenai kebijakan pokok Perusahaan.'
        },
        card2: {
          title: 'Board Manual',
          description:
            'Board Manual merupakan dokumen yang menjelaskan secara garis besar hak, kewajiban, tugas, wewenang, Dewan Komisaris dan Direksi sebagai Organ Utama Perusahaan serta proses hubungan dan fungsi anatara kedua organ tersebut.'
        },
        card3: {
          title: 'Pedoman COC',
          description:
            'Pedoman Etika Perusahaan merupakan acuan dalam melakukan interaksi di antara manajemen, pegawai serta para pemangku kepentingan (stakeholder) sesuai dengan nilai dan budaya perusahaan dan prinsip-prinsip GCG. COC ini mengatur mengenai apa yang patut dan tidak patut, baik dan tidak baik, hal-hal yang terpuji dan yang tercela, serta hal-hal yang dihargai dan tidak dihargai yang dilakukann oleh pegawai IP dalam relasinya dengan semua stakeholder Perusahaan.'
        },
        card4: {
          title: 'Pedoman Pengendalian Gratifikasi',
          description:
            'Kebijakan Pengendalian Gratifikasi memberikan panduan bagi pegawai untuk memahami definisi dan konsep Gratifikasi serta memahami cara bersikap apabila menghadapi adanya praktik Gratifikasi.'
        }
      }
    },

    audit: {
      title: 'PIAGAM SATUAN PENGAWAS INTERN',
      description:
        'Piagam Satuan Pengawas Intern merupakan dokumen formal yang menjelaskan struktur dan kedudukan Unit Satuan Pengawas Intern, kualifikasi, ruang lingkup kerja operasional, wewenang, tanggungjawab, standar professional, hubungan dengan auditor eksternal dan Komite Audit, kode etik, serta independensi dan obyektivitas SPI. Piagam Satuan Pengawas Intern menjadi dasar bagi SPI dalam melaksanakan tugasnya serta sifatnya mengikat kepada seluruh unit kerja dan anak perusahaan.'
    },

    companyStory: {
      title: 'Sejarah Perusahaan',
      paragraph1:
        'PT Pupuk Indonesia Utilitas ("Pl Utilitas") yang semula bernama PT Pupuk Indonesia Energi ("Pl Energi") merupakan Perusahaan yang menjalankan kegiatan usaha di bidang energi dan utilitas yang didirikan berdasarkan instruksi Presiden Republik Indonesia No.2 tahun 2010 tentang revitalisasi industri pupuk di Indonesia. Menindaklanjuti instruksi tersebut pada 18 Agustus 2014, PT Pupuk Indonesia (Persero) bersama PT Petrokimia Gresik, PT Pupuk Kalimantan Timur, PT Pupuk Sriwidjaja Palembang, PT Pupuk Kujang, PT Pupuk Iskandar Muda dan PT Rekayasa Industri mendirikan PT Pupuk Indonesia Energi yang bertujuan untuk meningkatkan efisiensi biaya produksi pupuk oleh BUMN pupuk melalui usaha penggunaan teknologi penyediaan energi yang hemat bahan bakar sekaligus ramah lingkungan.',
      paragraph2:
        'Pada saat didirikan, PI Utilitas (d/h PI Energi) diarahkan menjadi perusahaan yang menyediakan energi baik untuk mendukung kegiatan usaha Grup Pupuk Indonesia maupun untuk kepentingan umum. Pendirian PI Utilitas (d/h Pl Energi) salah satu andalan bisnis utama dalam peta jalan rencana investasi strategis PT Pupuk Indonesia (Persero), selain itu juga sebagai cikal bakal transformasi bisnis Grup Pupuk Indonesia dan mempererat sinergi antar Perusahaan dengan mengubah cost center menjadi profit center.',
      paragraph3:
        'Pada tahun 2015, Pl Utilitas memulai konstruksi untuk investasi pertamanya yaitu Pabrik Gresik Gas Cogeneration Plant (GGCP) yang memiliki 1 (satu) unit Gas Turbine Generator (GTG) dengan kapasitas terpasang 22 MW, 1 (satu) unit Heat Recovery Steam Generator (HRSG) dengan kapasitas terpasang 60 tph, dan 1 (satu) unit Package Boiler (PB) dengan kapasitas terpasang 100 tph. Sebagai langkah strategis dalam memperkuat portofolio bisnis, pada tahun 2016 Pl Utilitas mengakuisisi PT Kaltim Daya Mandiri (KDM), pemilik fasilitas Cogeneration Plant di Bontang, yang mencakup GTG 34 MW, HRSG 156 tph, Nitrogen Plant 1500 Nm3/jam, SWRO 2x50 m3/jam, serta jaringan integrasi listrik untuk kebutuhan pabrik PT Pupuk Kalimantan Timur (PKT) dan perusahaan-perusahaan yang ada di Kawasan Industrial Estate (KIE) Bontang.',
      paragraph4:
        'Dalam rangka mendukung transisi energi bersih dan efisiensi operasional melalui pemanfaatan sumber energi ramah lingkungan. Pl Utilitas bersama anak Perusahaan merealisasikan pembangunan Pembangkit Listrik Tenaga Surya (PLTS) di atap ruang kontrol dan area pergudangan pabrik GGCP dengan total kapasitas terpasang sebesar 20 kWp, selain itu melalui PT Kaltim Daya Mandiri yang merupakan Anak Perusahaan Pl Utilitas melakukan pembangunan PLTS dengan kapasitas terpasang 1.256,04 kWp di area kantor pusat PT Pupuk Kalimantan Timur (PKT), PLTS di area Plant site KDM sebesar 82,6 kWp dan PLTS Atap sebesar 2.612,94 kWp di area workshop dan pergudangan PKT, yang semuanya telah beroperasi dengan baik.'
    },

    Komisaris: {
      titleKomisaris: 'Dewan Komisaris',
      komisarisutama: 'Komisaris Utama',
      komisaris: 'Komisaris',
      komisarisindependen: 'Komisaris Independen',
      modal: {
        title: 'Biodata',
        nameLabel: 'Nama',
        nameValue: 'Sumyana Sukandar',
        birthLabel: 'Tempat, Tanggal Lahir',
        birthValue: 'Bandung, 11 September 1964',
        eduLabel: 'Pendidikan',
        education: {
          item1:
            'Magister Manajemen dari STIE IPWIJA Jakarta (2000-2002)',
          item2: 'Sarjana Ekonomi jurusan Manajemen dari Universitas Pasundan Bandung (1983-1988)',
          item3: 'SMA Negeri IX IPA, Bandung 1980-1983 ',
          item4: 'SMP Negeri XIV Bandung (1977–1980)'
        },
        expLabel: 'Pengalaman',
        experience: {
          item1:
            'Menjabat sebagai Komisaris Utama PT Pupuk Indonesia Utilitas pada 2021–Sekarang',
          item2: 'Komisaris PT Kimia Farma Trading & Distribusi pada 2020–2021',
          item3:
            'Analis Data dan Informasi (Golongan IV D) Kementerian BUMN pada 2018–2021',
          item4: 'Direktur I Perum Jasa Tirta II pada 2016–2018',
          item5: 'Direktur Administrasi dan Keuangan Perum Jasa Tirta II pada 2015',
          item6: 'Komisaris PT Asuransi Jiwasraya (Persero) pada 2012–2015',
          item7:
            'Asisten Deputi Usaha Perkebunan dan Kehutanan pada Kedeputian Bidang Usaha Industri Agro dan Industri Strategis',
          item8: 'Asisten Deputi Bidang Usaha Industri Primer III pada 2012–2014',
          item9: 'Komisaris PT Sucofindo pada 2012',
          item10: 'Komisaris PT HK Realtindo pada 2010–2012',
          item11:
            'Komisaris/Ketua Dewan Komite Audit PT Nindya Karya (Persero) pada 2007–2012',
          item12:
            'Kepala Bidang Usaha Jasa Perencanaan Konstruksi dan Rekayasa II pada Deputi Bidang Usaha Jasa Lainnya pada 2006–2010',
          item13:
            'Sekretaris Dewan Komisaris PT Perkebunan Nusantara X (Persero) pada 2003–2009',
          item14:
            'Sekretaris Dewan Komisaris PT Bank Tabungan Negara (Persero) pada 1996–2007',
          item15:
            'Direktorat Jenderal Pembinaan BUMN, Departemen Keuangan pada 2001–2002',
          item16:
            'Kepala Subbagian Administrasi pada Kementerian Negara BUMN hingga 2000',
          item17:
            'Kepala Seksi Ditjen Pembinaan BUMN, Departemen Keuangan hingga 1998',
        }
      },
      modal3: {
        title: 'Biodata',
        nameLabel: 'Nama',
        nameValue: 'Hazmi Fitriyasa',
        birthLabel: 'Tempat, Tanggal Lahir',
        birthValue: 'Semarang, 23 Agusuts 1979',
        eduLabel: 'Pendidikan',
        education: {
          item1: 'SMK Telkom Sandhy Putra Purwkerto (1998)',
           item2: 'Sarjana Teknik Elektro Universitas Mercu Buana (2012)',
            item3: 'Magister Ilmu Komunikasi Universitas Mercu Buana (2023)'
        },
        expLabel: 'Pengalaman',
        experience: {
          item1:'Staff di PT Indosat Tbk pada 1998 – 2000',
          item2:'Network Engineer di PT Indosat Tbk pada 2000 – 2002',
          item3: 'Business Analyst Expert di PT Indosat Tbk pada 2002 – 2006',
          item4: 'Expert of Corporate Communication di PT Indosat Tbk pada 2006 – 2008',
          item5: 'Assistance of Chief Corporate Services di PT Indosat Tbk pada 2012 – 2018',
          item6:'Direktur di DIGDAYA TV pada 2018 – 2021',
          item7: 'Direktur di GARUDA TV pada 2021 – 2023',
          item8: 'Direktur Utama di PT. Beautivi Kilau Indonesia pada 2023 – 2025',
          item9: 'Komisaris di PT Pupuk Indonesia Utilitas pada 2025 - Sekarang',
        }
        },
        modal4: {
          title: 'Biographical Data',
          nameLabel: 'Name',
          nameValue: 'Binbin Firman Tresnadi',
          birthLabel: 'Tempat, Tanggal Lahir',
          birthValue: 'February 16, 1975',
          eduLabel: 'Education',
          education: {
            item1: 'Sarjana Manajemen Sekolah Tinggi Ilmu Ekonomi AL-ANWAR Mojokerto (2016 – 2020)',
            item2: 'Universitas Pasundan Bandung (2025 – Present)',
          },
          expLabel: 'Experience',
          experience: {
            item1:'Dewan Redaksi di Berdikari Online pada 2007 – Sekarang',
            item2:'Direktur Eksekutif di Indonesia Development Monitoring pada 2014 – 2020',
            item3: 'Staf Khusus Wakil menteri Kesekretariatan Negara pada 2025 – Sekarang',
          }
        },
        modal5: {
          title: 'Biodata',
          nameLabel: 'Nama',
          nameValue: 'Eva Yulianti, S.H., M.H.',
          birthLabel: 'Tempat, Tanggal Lahir',
          birthValue: '11 Juni 1971',
          eduLabel: 'Pendidikan',
          education: {
            item1: 'Magister Ilmu Hukum, Universitas Jayabaya, Jakarta (2016-2018)',
            item2: 'Sarjana Ilmu Hukum, Universitas Indonesia, Depok (2007-2011)'
          },
          expLabel: 'Pengalaman',
          experience: {
            item1: 'Managing Partner dan Founder Kantor Hukum Eva Yulianti & Rekan, Jakarta (2017 - Sekarang)',
            item2: 'Associate Lawyer Kantor Hukum Herman Kadir & Partners, Jakarta (2012 - 2017)',
            item3: 'Legal pada PT Agung Podomoro Group Tbk untuk proyek Perumahan Grand Taruma, Karawang (2011 - 2012)',
            item4: 'Kepala Bidang Pengembangan & Penelitian Hukum pada Dewan Pimpinan Pusat Kongres Advokat Indonesia (2020 - 2025)',
            item5: 'Aktif dalam kegiatan Pemilu Raya Alumni FHUI, Depok (2021 dan 2024)',
            item6: 'Kepala Bidang Konstitusi pada Dewan Pimpinan Pusat Kongres Advokat Indonesia (2014 - 2019)',
            item7: 'Aktif di Organisasi Forum Silahturahmi Anak Bangsa (2008 - 2012)',
            item8: 'Aktif menangani perkara perdata, pidana umum dan khusus, pertanahan dan properti, perselisihan hubungan industrial, tata usaha negara, serta konsultan hukum perusahaan sejak 2017',
            item9: 'Menangani perkara tindak pidana korupsi pada Pengadilan Tipikor Jakarta Pusat (April 2025 - Maret 2026)',
            item10: 'Tim Kuasa Hukum Pemilihan Bupati dan Wakil Bupati Kabupaten Waropen, Papua, di Mahkamah Konstitusi (2020 dan 2024)',
            item11: 'Tim Kuasa Hukum Perkara Hubungan Industrial PT Sandiego Hills, Karawang (2020)',
            item12: 'Tim Kuasa Hukum Pemilu Legislatif pada Mahkamah Konstitusi (2019)',
            item13: 'Tim Kuasa Hukum Yayasan Rumah Sakit Islam Fatimah Cilacap (2019)',
            item14: 'Tim Kuasa Hukum Pemilihan Bupati dan Wakil Bupati Kabupaten Bogor (2018)',
            item15: 'Tim Kuasa Hukum Pimpinan Dewan Perwakilan Daerah Republik Indonesia (2018)',
            item16: 'Tim Kuasa Hukum Swiss German University, Tangerang Selatan (2015)',
            item17: 'Tim Kuasa Hukum pada beberapa perkara pemilihan kepala daerah dan pemilihan legislatif di Mahkamah Konstitusi (2012 - 2017)',
          }
        }
      },

    Direktur: {
      titleDirektur: 'Direksi',
      direkturutama: 'Direktur Utama',
      direktur: 'Direktur',
      modal: {
        title: 'Biodata',
        nameLabel: 'Nama',
        nameValue: 'Iwan Daru Sukmana',
        birthLabel: 'Tempat, Tanggal Lahir',
        birthValue: 'Yogyakarta, 27 Januari 1978',
        eduLabel: 'Pendidikan',
        education: {
          item1: 'S2  Manajemen Universitas Prasetya Mulya (masih menempuh)',
          item2: 'Teknik Kimia (Profesi) Institute Teknologi Bandung (2023)',
          item3: 'Sarjana Teknik Kimia Universitas Gajah Mada (2023)'
        },
        expLabel: 'Pengalaman',
        experience: {
          item1:'Pelaksana Tugas Direktur Utama PT Pupuk Indonesia Utilitas (5 Maret 2026 - sekarang)',
          item2:'Direktur Utama PT Pupuk Indonesia Pangan (13 November - 5 Maret 2026)',
          item3: 'SVP Pengembangan PT Pupuk Indonesia (Persero) (5 Agustus 2021 - 12 November 2023)',
          item4: 'VP/Kordinator Proyek PT Pupuk Indonesia (Persero) (1 November 2017 - 5 Agustus 2021)',
          item5: 'VP Pengembangan PT Pupuk Kujang (9 Januari 2014 - 31 Oktober 2017)'
        }
      },
      modal2: {
        titlefront: 'Direktur Keuangan',
        title: 'Biodata',
        nameLabel: 'Nama',
        nameValue: 'Nuri Kristiawan',
        birthLabel: 'Tempat, Tanggal Lahir',
        birthValue: 'Surabaya, 27 Januari 1971',
        eduLabel: 'Pendidikan',
        education: {
          item1:
            'Sarjana Mathematics Educations, Universita Sanata Dharma Yogyakarta (1996)'
        },
        expLabel: 'Pengalaman',
        experience: {
          item1:
            'Direktur Keuangan PT Pupuk Indonesia Utilitas (20 Januari 2022 - Sekarang)',
          item2: 'Direktur Keuangan PT Gresik Cipta Sejahtera (2019-2021)',
          item3:
            'Chief Administration and Finance Site Office PT Rekayasa Industri (2017-2019)',
          item4:
            'Chief Administration and Finance Head Office PT Rekayasa Industri (2015-2017)',
          item5:
            'Administration and Finance Head Office PT Rekayasa Industri (2009-2015)'
        }
      },
      modal3: {
        titlefront: 'Direktur Operasi',
        title: 'Biodata',
        nameLabel: 'Nama',
        nameValue: 'Anis Ernanis',
        birthLabel: 'Tempat, Tanggal Lahir',
        birthValue: 'Surabaya, 10 Januari 1968',
        eduLabel: 'Pendidikan',
        education: {
          item1:
            'Sarjana Teknik Kimia Institut Teknologi Sepuluh Nopember (1991)',
          item2: 'Master Teknik Kimia Institut Teknologi Sepuluh Nopember (2007)'
        },
        expLabel: 'Pengalaman',
        experience: {
          item1:
            'Direktur Operasi PT Pupuk Indonesia Utilitas (20 Januari 2022 - Sekarang)',
          item2: 'DPB Direktur Utama Petrokimia Kayaku (2018-2021)',
          item3: 'GM Teknologi PT Petrokimia Gresik (2015-2017)',
          item4: 'GM Pengembangan PT Petrokimia Gresik (2014-2015)'
        }
      }
    },

    produk: {
      title: 'Gresik Gas Cogeneration Plant',
      description:
        'PT Pupuk Indonesia Utilitas (PI Utilitas) atau sebelumnya bernama PT Pupuk Indonesia Energi didirikan berdasarkan Akta No. 11 tanggal 18 Agustus 2014. Di tahun yang sama terjadi pula inisiasi Pembangunan Gresik Gas Cogeneration Plant (GGCP di Gresik, Jawa Timur). Pada 2015, PI Utilitas mulai melakukan Konstruksi Fisik Gresik Gas Cogeneration Plant. Tepat pada April 2018, Pabrik GGCP resmi beroperasi secara komersil hingga saat ini.',
      description2:
        'Proyek GGCP yang sudah mulai dijalankan dan dioptimalkan di tahun 2018 senantiasa mendorong Kinerja PI Utilitas untuk terus unggul dalam persaingan usaha tanpa melupakan tanggung jawabnya sebagai korporasi yang tumbuh di tengah publik. Dengan mengedepankan prinsip penerapan bisnis yang tetap memperhatikan lingkungan, PI Utilitas yakin akan mampu terus tumbuh menjadi korporasi yang berkelanjutan dan berintegritas tinggi.'
    },

    anakPerusahaan: {
      title: 'Kaltim Daya Mandiri',
      description: 'Kaltim Daya Mandiri (KDM) adalah salah satu perusahaan utilitas dan energi yang didirikan dengan tujuan untuk menyuplai kebutuhan utilitas pada fasilitas produksi dan perumahan PT Pupuk Kaltim serta perusahan-perusahaan lain yang berada di lingkungan Kaltim Industrial Estate.',
      description2: 'PT Kaltim Daya Mandiri (KDM), sebagai anak perusahaan PT Pupuk Indonesia Utilitas, berdiri sejak 14 September 1995. Awalnya, KDM menginvestasikan 1 unit Gas Turbine Generator (GTG) 34 MW, kemudian menambahkan 1 unit Heat Recovery Steam Generator (HRSG) 168 ton/jam dan 1 unit Demin Water Plant 156 m³/h pada tahun 2000. Pada tahun-tahun berikutnya, KDM membangun 1 unit Nitrogen Plant 500 Nm³/h, integrasi kelistrikan 200 MVA, dan 1 unit SWRO 2x50 m³/h. Di 2008, KDM membentuk anak usaha PT KDM Argo Energy dan mengakuisisi perusahaan energi terbarukan, PT Banyumas Energy Lestari dan PT Mitra Daya Kencana, pada 2015.',
      description3: 'Bisnis utama KDM adalah memproduksi listrik, steam, demineralized water, nitrogen, dan jasa integrasi listrik untuk kebutuhan pabrik Pupuk Kaltim dan perusahaan-perusahaan yang ada di kawasan industri.'
    },

    operasiPemeliharaan: {
      title: 'Operasi & Pemeliharaan',
      subtitle: 'Strategi Kami',
      bodytitle: 'Memberikan layanan O&M menyeluruh yang memastikan ketersediaan, keandalan, dan efisiensi sistem energi & utilitas industri – melalui layanan terbaik, predictive maintenance, dan tim expertise operasional',
      leftTitle: 'Layanan Kami',
      serviceBox: {
        box1: 'Power Plant (Gas, Coal, etc) Operation & Maintenance'
      }
    },

    perencanaanProyek: {
      title: 'Perencanaan Proyek & Pendanaan',
      section1: {
        title: '1. Feasibility study & business case preparation',
        bullet1: 'Penilaian teknis, keuangan, dan peraturan',
        bullet2: 'Analisis pasar dan permintaan'
      },
      section2: {
        title: '2. Project structuring & investment modelling',
        bullet1: 'BOO, BOT, leasing, dll.',
        bullet2: 'Alokasi risiko dan sistem revenue-sharing'
      },
      section3: {
        title: '3. Partner identification & consortium building',
        bullet1: 'Aliansi strategis dengan technology provider, EPC, dan investor',
        bullet2: 'Keterlibatan klien pengambil alih industri dan utilitas' 
      },
      section4: {
        title: '4. Financing & capital raising support',
        bullet1: 'Penataan pembiayaan proyek (ekuitas, utang, pembiayaan campuran)',
        bullet2: 'Kolaborasi dengan bank dan investor' 
      }
    },

    pengalamanKami: {
      title: 'Pengalaman Kami di SOLAR PV',
      colum1: {
          bullet1: '8 kWp : Rooftop CRR Pabrik GGCP, Gresik'
      },
      colum2: {
          bullet1: '1.256 kWp : Rooftop Kantor Pusat PKT, Bontang'
      },
      colum3: {
        bullet1: '12 kWp : Rooftop Bengkel Pabrik GGCP, Gresik',
        bullet2: '83 kWp : Rooftop Plant Site KDM, Bontang',
      },
      colum4: {
        bullet1: '2.613 kWp : Rooftop Workshop dan Pergudangan PKT, Bontang',
      },
      colum5: {
        bullet1: '495 kWp : Warehouse PT Pupuk Kujang, Cikampek'
      }
    },


    tabs: {
      env_policy: 'Kebijakan Lingkungan',
      hse_energy: 'Kebijakan K3LH & Konservasi Energi',
      sustain_commitment: 'Komitmen Keberlanjutan',
      sustain_priority: 'Prioritas Keberlanjutan',
      csr: 'Kegiatan CSR'
    },


    keberlanjutan: {
      title: 'Tujuan Pembangunan Berkelanjutan',
      tab1: {
         title: 'Kebijakan Lingkungan',
         desc: 'PT Pupuk Indonesia Utilitas berkomitmen menjalankan operasional yang berwawasan lingkungan dengan mematuhi peraturan, mengurangi dampak pencemaran, dan mengelola sumber daya alam secara berkelanjutan. Kami terus meningkatkan kinerja lingkungan melalui efisiensi, mitigasi perubahan iklim, pelestarian keanekaragaman hayati, serta kerja sama dengan masyarakat sekitar.' 
      },
      tab2: {
         title: 'Kebijakan K3LH & Konservasi Energi',
         desc: 'PT Pupuk Indonesia Utilitas berkomitmen menerapkan budaya Keselamatan, Kesehatan Kerja, dan Lingkungan Hidup (K3LH) serta Konservasi Energi di seluruh kegiatan operasional. Kami memastikan setiap aktivitas berjalan aman, efisien, ramah lingkungan, serta mematuhi peraturan yang berlaku untuk mencapai kinerja berkelanjutan dan zero accident.'
      },
      tab3: {
          title: 'Komitemen Keberlanjutan',
          desc: 'PT Pupuk Indonesia Utilitas berkomitmen menjalankan operasional yang selaras dengan prinsip Environmental, Social & Governance (ESG) untuk mendukung pembangunan berkelanjutan. Kami berupaya menjaga keseimbangan antara kinerja bisnis dan tanggung jawab lingkungan, sosial, serta tata kelola dengan mengelola sumber daya secara bertanggung jawab, berkontribusi pada pemberdayaan masyarakat, dan menegakkan tata kelola yang transparan, etis, serta akuntabel.'
      },
      tab4: {
          title: 'Prioritas Keberlanjutan SDG',
          subtitle1: 'Treevolution',
          desc1: 'Program revolusi hijau untuk mendorong penanaman pohon secara masif sebagai upaya mendukung keberlanjutan lingkungan dan program dekarbonisasi.',
          subtitle2: 'PIU Academy',
          desc2: 'Kegiatan pengembangan kapasistas siswa SMA di Jakarta bersama Board of Director Utilitas dalam mengenalkan Utilitas.',
          subtitle3: 'Pengembangan Desa Wisata Pecuk Indah Ecoriparian',
          desc3: 'Pembinaan penyusunan Paket Program Ekowisata Pecuk Indah Ecorparian. Kegiatan tersebut menghasilkan beberapa output program yang bisa dilaksanakan di desa wisata. Antara lain:',
          bullet1: 'Basic Ecowisata: Susur Sungai dan Pemandu Wisata',
          bullet2: 'Spekta Ekowisata: Susur Sungai, Pemandu Wisata dan Souvenir (sirup nipah, totebag & gantungan kunci)'
      },
      tab5: {
          title: 'Corporate Social Responsibility',
          desc: 'Sebagai salah satu bentuk dari tanggung jawab sosial perusahaan terhadap konsumen, karyawan, pemegang saham, komunitas dan lingkungan dalam segala aspek operasional perusahaan. PT Pupuk Indonesia Utilitas berkomitmen untuk memberikan bantuan dan melakukan kegiatan sosial untuk masyarakat terutama yang berada di sekitar wilayah operasional Perusahaan.'
      } 
        },



      

    portfolioEnergi: {
      title: 'Portfolio Energi Terbarukan & Energi Bersih',
      titleRight: '"Mendorong transisi energi dengan berinvestasi pada aset energi terbarukan yang terukur, rendah karbon, dan siap untuk masa depan untuk mendukung dekarbonisasi industri dan tujuan keberlanjutan nasional."',
      section1: {
        title: '1. Solar PV (PLTS)',
        bullet1: 'Ground mounted, Rooftop, dll.',
        bullet2: 'Aplikasi On-grid dan Off-grid'
      },
      section2: {
        title: '2.Energy Storage System (ESS)',
        bullet1: 'Sistem Penyimpanan Energi Baterai (BESS) untuk mendukung jaringan listrik',
        bullet2: 'Proyek hibrida tenaga surya + penyimpanan'
      },
      section3: {
        title: '3. Project Development & Co-Investment',
        bullet1: 'Model BOO/BOT dengan klien dan IPP',
        bullet2: 'Kemitraan dengan pengembang atau kawasan industri'
      },
      section4: {
        title: '4. Research & Development in Green Energy',
        bullet1: 'Pencarian teknologi untuk solusi energi bersih yang sedang berkembang',
        bullet2: 'Kolaborasi dengan universitas, pusat penelitian, dan penyedia teknologi'
      },
    },

    expertiseStrategy: {
      title: 'Keahlian & Strategi Perusahaan',
      leftTitle: 'Keahlian Kami',
      rightTitle: 'Strategi Inti Perusahaan',
      expertiseItems: {
        skill1: 'Gas Turbine Generator',
        skill2: 'Heat Recovery Steam Generator',
        skill3: 'Boiler',
        skill4: 'Water Treatment Plant',
        skill5: 'Wastewater Treatment Plant',
        skill6: 'Nitrogen & Oxygen Plant',
        skill7: 'Electricity Integration'
      },
      strategySteps: {
        item1: 'Mengembangkan ekosistem energi & utilitas yang tangguh dan berkelanjutan melalui investasi strategis di bidang infrastruktur energi & utilitas',
        item2: 'Berfokus pada penciptaan nilai jangka panjang melalui investasi strategis di bidang energi dan aset utilitas',
        item3: 'Memberdayakan industri dengan solusi energi & utilitas yang terukur'
      }
    }
  },

  en: {
    menuProfile: {
      mainmenu: 'Profil',
      submenu1: 'Company History',
      submenu2: 'Management',
      submenu3: 'Organizational Structure',
      submenu4: 'Awards'
    },
    menuTatakelola: {
      mainmenu: 'Governance',
      submenu1: 'Governance Guidelines',
      submenu2: 'Audit Charter'
    },
    menuProduklayanan: {
      mainmenu: 'Product & Services',
      submenu1: 'Product',
      submenu2: 'Services',
      submenu3: 'Subsidiary Company'
    },
    menuLaporan: {
      mainmenu: 'Report',
      submenu1: 'Annual Report',
      submenu2: 'Financial Statement',
      submenu3: 'Sustainability Report'
    },
    menuBerita: {
      mainmenu: 'News',
      submenu1: 'Articles',
      submenu2: 'Press Release',
      submenu3: 'Bulletin Buzz',
      moreArticles: 'More Articles',
      morePress: 'More Press Releases',
      readMore: 'Read more'
     },
    menuKeberlanjutan: {
      mainmenu: 'Sustainability'
    },
    menuKontak: {
      mainmenu: 'Contact Us'
    },
    pageKontak: {
      title: 'Contact Us',
      heading: 'Headquarters',
      subtitle: 'Your opinion is very important to us. Send us a message using the form below or via the contact details below.',
      field1: 'Full Name',
      field2: 'Phone Number',
      field3: 'E-Mail',
      field4: 'Message'
    },
    companyPillars: {
      subtitle:
        'Building a strong and sustainable foundation for the success of PT Pupuk Indonesia Utilitas',
      vision:
        'To become a world-class integrated energy and utilities company supporting the core business of PT Pupuk Indonesia (Persero) and its subsidiaries.',
      visionTitle: 'Vision',
      missionTitle: 'Mission',
      mission: {
        item1:
          'Engaging in business activities in the field of energy and utility supply.',
        item2: 'Providing added value to stakeholders.',
        item3:
          'Prioritizing occupational safety and health and preserving the environment in all operational activities.',
        item4: 'Contributing to national energy security.'
      },
      businessLine: {
        title1: 'Electricity and Steam Supply',
        title2: 'Industrial Water Supply and Demineralization',
        title3: 'Industrial Gas',
        title4: 'Operation and Maintenance (O&M)',
        title5: 'Provision of Other Utility Solutions',
        title5sub:
          'Electricity Integration, Shore to Ship Connection, Solar Power Plant, Electric Vehicle Charging Station, etc.'
      },
      businessEnabler: {
        card1: 'Business Development',
        card2: 'Supply Chain',
        card3: 'Operasional Efficiency',
        card4: 'IT System'
      }
    },

    businessProfile: {
      title: 'Company Business Portfolio',
      subtitle:
        'PT Pupuk Indonesia Utilitas has production facility assets in two locations, namely:',
      fasilitas: {
        item1:
          'Gresik Gas Cogeneration Plant in Gresik: GTG 22 MW, HRSG 60 tph, PB 100 tph',
        item2:
          'Cogeneration Plant in Bontang, through its subsidiary PT Kaltim Daya Mandiri (KDM): GTG 34 MW, HRSG 156 tph, N2 Plant 500 Nm3/h, SWRO 2x50 m3/h, and integrated electricity network. Through its subsidiary PT Kaltim Daya Mandiri Agro Energy (KDM-AE), KDM is developing its business line in coal trading. By 2019, KDM-AE had shipped up to 270,000 MT/year of coal to East Kalimantan and West Sulawesi.'
      }
    },

    tataKelolah: {
      title:
        'PT Pupuk Indonesia Utilitas Commitment to Implementing Good Corporate Governance',
      subtitle:
        'In order to achieve the companys goal of becoming a solution provider for the national agro-industrial sector, the Board of Directors and Board of Commissioners of PT Pupuk Indonesia Utilitas are committed to:',
      items: [
        'Conducting all transactions and decision-making based on the principles of Good Corporate Governance (GCG) and compliance with applicable laws and regulations.',
        'To perform duties and responsibilities in accordance with the Good Corporate Governance Guidelines, Board Policy Manual, Business Ethics & Work Ethics Guidelines, and other supporting guidelines related to the consistent and responsible implementation of GCG.',
        'Implement other guidelines related to the application of GCG for all PI Utilitas personnel in order to create an ethical and dignified work environment.',
        'Apply company management and financial reports that are presented transparently, accurately, and in a timely manner, and ensure that other transparency obligations are fulfilled in accordance with applicable laws and regulations.',
        'Setting an example in all matters and creating a conducive environment for the implementation of PI Utilitass clean practices against corruption, collusion, and nepotism, as well as fraud and other legal violations, by applying strict sanctions for any violations.'
      ],
      closing:
        'The commitment of the Board of Directors and Board of Commissioners to the implementation of Good Corporate Governance is carried out in the Guidelines for the Implementation of Good Corporate Governance (GCG Guidelines) as attached:',
      documents: {
        card1: {
          title: 'GCG Guidelines',
          description:
            'Corporate Governance contains the Strategic Directions of the Board of Directors and Board of Commissioners in the Implementation of GCG in the Company and serves as the parent policy of the company which is a reference for all activities of PT Pupuk Indonesia Utilitas, including the relationship between the Company and its Shareholders, the functions and roles of the Board of Commissioners and Board of Directors, the Companys relationship with stakeholders, and the principles governing the Companys basic policies.'
        },
        card2: {
          title: 'Board Manual',
          description:
            'The Board Manual is a document that outlines the rights, obligations, duties, and authorities of the Board of Commissioners and Board of Directors as the Companys Main Organs, as well as the relationship and functions between these two organs.'
        },
        card3: {
          title: 'COC Guidelines',
          description:
            'The Corporate Code of Ethics serves as a reference for interactions between management, employees, and stakeholders in accordance with the companys values and culture and the principles of GCG. This COC regulates what is appropriate and inappropriate, good and bad, commendable and reprehensible, as well as what is valued and not valued in the actions of IP employees in their relationships with all Company stakeholders.'
        },
        card4: {
          title: 'Guidelines for Controlling Gratuities',
          description:
            'The Gratuity Control Policy provides guidance for employees to understand the definition and concept of gratuity and how to respond when encountering gratuity practices.'
        }
      }
    },

    audit: {
      title: 'CHARTER OF INTERNAL AUDIT UNIT',
      description:
        'The Internal Audit Charter is a formal document that describes the structure and position of the Internal Audit Unit, qualifications, scope of operational work, authority, responsibilities, professional standards, relationships with external auditors and the Audit Committee, code of ethics, as well as the independence and objectivity of the Internal Audit Unit. The Internal Audit Charter serves as the basis for the Internal Audit Unit in carrying out its duties and is binding on all work units and subsidiaries.'
    },

    companyStory: {
      title: 'Company History',
      paragraph1:
        'PT Pupuk Indonesia Utilitas (“Pl Utilitas”), formerly known as PT Pupuk Indonesia Energi (“Pl Energi”), is a company engaged in energy and utility businesses established based on Presidential Instruction No. 2 of 2010 concerning the revitalization of the fertilizer industry in Indonesia. Following up on this instruction, on August 18, 2014, PT Pupuk Indonesia (Persero) together with PT Petrokimia Gresik, PT Pupuk Kalimantan Timur, PT Pupuk Sriwidjaja Palembang, PT Pupuk Kujang, PT Pupuk Iskandar Muda, and PT Rekayasa Industri established PT Pupuk Indonesia Energi with the aim of increasing the production cost efficiency of state-owned fertilizer companies through the use of fuel-efficiency and environmentally friendly energy supply technologies.',
      paragraph2:
        'When it was established, PI Utilitas (formerly PI Energi) was intended to be a company that provided energy to support the business activities of the Pupuk Indonesia Group as well as for the public interest. The establishment of PI Utilitas (formerly PI Energi) is one of the main business pillars in the strategic investment roadmap of PT Pupuk Indonesia (Persero). It also serves as the foundation for the business transformation of the Pupuk Indonesia Group and strengthens synergies between companies by transforming cost centers into profit centers.',
      paragraph3:
        'In 2015, Pl Utilitas began construction on its first investment, the Gresik Gas Cogeneration Plant (GGCP), which has 1 (one) Gas Turbine Generator (GTG) unit with an installed capacity of 22 MW, one Heat Recovery Steam Generator (HRSG) unit with an installed capacity of 60 tph, and one Package Boiler (PB) unit with an installed capacity of 100 tph. As a strategic step in strengthening its business portfolio, in 2016 Pl Utilitas acquired PT Kaltim Daya Mandiri (KDM), the owner of a cogeneration plant facility in Bontang, which includes a 34 MW GTG, a 156 tph HRSG, a 1500 Nm3/hour nitrogen plant, SWRO 2x50 m3/hour, as well as an integrated electricity network for the needs of PT Pupuk Kalimantan Timur (PKT) and companies located in the Bontang Industrial Estate (KIE).',
      paragraph4:
        'In order to support the transition to clean energy and operational efficiency through the use of environmentally friendly energy sources. Pl Utilitas, together with its subsidiaries, has realized the construction of a Solar Power Plant (PLTS) on the roof of the control room and warehouse area of the GGCP factory with a total installed capacity of 20 kWp. In addition, through PT Kaltim Daya Mandiri, a subsidiary of Pl Utilitas, a PLTS with an installed capacity of 1,256.04 kWp has been constructed in the head office area of PT Pupuk Kalimantan Timur (PKT), an 82.6 kWp PLTS at the KDM plant site, and a 2,612.94 kWp rooftop PLTS at the PKT workshop and warehouse area, all of which are operating well.'
    },

    Komisaris: {
      titleKomisaris: 'Board of Commissioner',
      komisarisutama: 'President Commissioner',
      komisaris: 'Commissioner',
      komisarisindependen: 'Independent Commissioner',
      modal: {
        title: 'Biographical Data',
        nameLabel: 'Name',
        nameValue: 'Sumyana Sukandar',
        birthLabel: 'Place, Date of Birth',
        birthValue: 'Bandung, September 11, 1964',
        eduLabel: 'Education',
        education: {
          item1:'Master of Management from STIE IPWIJA Jakarta (2002)',
            
          item2: 'Bachelor of Economics majoring in Management from Pasundan University Bandung (1988)',
          item3:
            'State Senior High School IX Bandung, Natural Sciences major (1980–1983)',
          item4: 'State Junior High School XIV Bandung (1977–1980)'
        },
        expLabel: 'Experience',
        experience: {
          item1:
            'Serves as President Commissioner of PT Pupuk Indonesia Utilitas from 2021 to present',
          item2:
            'Commissioner of PT Kimia Farma Trading & Distribusi from 2020 to 2021',
          item3:
            'Data and Information Analyst (Class IV D) at the Ministry of State-Owned Enterprises from 2018 to 2021',
          item4: 'Director I of Perum Jasa Tirta II from 2016 to 2018',
          item5:
            'Director of Administration and Finance at Perum Jasa Tirta II in 2015',
          item6:
            'Commissioner at PT Asuransi Jiwasraya (Persero) from 2012 to 2015',
          item7:
            'Assistant Deputy for Plantation and Forestry Business at the Deputy for Agro Industry and Strategic Industry',
          item8: 'Assistant Deputy for Primary Industry III in 2012–2014',
          item9: 'Commissioner of PT Sucofindo in 2012',
          item10: 'Commissioner of PT HK Realtindo in 2010–2012',
          item11:
            'Commissioner/Chair of the Audit Committee of PT Nindya Karya (Persero) in 2007–2012',
          item12:
            'Head of Construction Planning and Engineering Services Division II at the Deputy for Other Services from 2006 to 2010',
          item13:
            'Secretary of the Board of Commissioners of PT Perkebunan Nusantara X (Persero) from 2003 to 2009',
          item14:
            'Secretary of the Board of Commissioners of PT Bank Tabungan Negara (Persero) from 1996 to 2007',
          item15:
            'Directorate General of State-Owned Enterprises Development, Ministry of Finance in 2001–2002',
          item16:
            'Head of Administration Subdivision at the Ministry of State-Owned Enterprises until 2000',
          item17:
            'Head of Section at the Directorate General of State-Owned Enterprises Development, Ministry of Finance until 1998',
        }
      },
      modal3: {
        title: 'Biographical Data',
        nameLabel: 'Name',
        nameValue: 'Hazmi Fitriyasa',
        birthLabel: 'Place, Date of Birth',
        birthValue: 'Semarang, 23 August 1979',
        eduLabel: 'Education',
        education: {
          item1: 'SMK Telkom Sandhy Putra Purwkerto (1998)',
          item2: 'Bachelor of Electrical Engineering, Mercu Buana University (2012)',
          item3: 'Master of Communication Science, Mercu Buana University (2023)'
        },
        expLabel: 'Experience',
        experience: {
          item1:'StaR at PT Indosat Tbk from 1998 to 2000',
          item2:'Network Engineer at PT Indosat Tbk from 2000 to 2002',
          item3: 'Business Analyst Expert at PT Indosat Tbk from 2002 to 2006',
          item4: 'Expert of Corporate Communication at PT Indosat Tbk from 2006 to 2008',
          item5: 'Assistant Chief Corporate Services at PT Indosat Tbk from 2012 to 2018',
          item6:'Director at DIGDAYA TV from 2018 to 2021',
          item7: 'Director at GARUDA TV from 2021 to 2023',
          item8: 'President Director at PT. Beautivi Kilau Indonesia from 2023 to 2025',
          item9: 'Commissioner at PT Pupuk Indonesia Utilitas from 2025 to present',
        }
      },
      modal4: {
        title: 'Biographical Data',
        nameLabel: 'Name',
        nameValue: 'Binbin Firman Tresnadi',
        birthLabel: 'Place, Date of Birth',
        birthValue: 'February 16, 1975',
        eduLabel: 'Education',
        education: {
          item1: 'Bachelor of Management, AL-ANWAR College of Economics, Mojokerto (2016 – 2020)',
          item2: 'Pasundan University, Bandung (2025 – Present)',
        },
        expLabel: 'Experience',
        experience: {
          item1:'Editorial Board at Berdikari Online from 2007 – Present',
          item2:'Executive Director at Indonesia Development Monitoring from 2014 – 2020',
          item3: 'Special StaR to the Deputy Minister of State Secretariat from 2025 – Present',
        }
      },
      modal5: {
        title: 'Biographical Data',
        nameLabel: 'Name',
        nameValue: 'Eva Yulianti, S.H., M.H.',
        birthLabel: 'Place, Date of Birth',
        birthValue: 'June 11, 1971',
        eduLabel: 'Education',
        education: {
          item1: 'Master of Law, Jayabaya University, Jakarta (2016-2018)',
          item2: 'Bachelor of Law, University of Indonesia, Depok (2007-2011)'
        },
        expLabel: 'Experience',
        experience: {
          item1: 'Managing Partner and Founder of Eva Yulianti & Partners Law Office, Jakarta (2017 - Present)',
          item2: 'Associate Lawyer at Herman Kadir & Partners Law Office, Jakarta (2012 - 2017)',
          item3: 'Legal officer at PT Agung Podomoro Group Tbk for the Grand Taruma Housing Project, Karawang (2011 - 2012)',
          item4: 'Head of Legal Development & Research Division at the Central Executive Board of the Indonesian Advocates Congress (2020 - 2025)',
          item5: 'Active in the University of Indonesia Faculty of Law Alumni Election activities, Depok (2021 and 2024)',
          item6: 'Head of Constitutional Affairs Division at the Central Executive Board of the Indonesian Advocates Congress (2014 - 2019)',
          item7: 'Active in Forum Silahturahmi Anak Bangsa organization (2008 - 2012)',
          item8: 'Actively handled civil cases, general and special criminal cases, land and property cases, industrial relations disputes, state administrative cases, and corporate legal consulting since 2017',
          item9: 'Handled corruption criminal cases at the Jakarta Central Corruption Court (April 2025 - March 2026)',
          item10: 'Legal team for the Regent and Deputy Regent Election of Waropen Regency, Papua, at the Constitutional Court (2020 and 2024)',
          item11: 'Legal team for the industrial relations case of PT Sandiego Hills, Karawang (2020)',
          item12: 'Legal team for legislative election cases at the Constitutional Court (2019)',
          item13: 'Legal team for Fatimah Cilacap Islamic Hospital Foundation (2019)',
          item14: 'Legal team for the Regent and Deputy Regent Election of Bogor Regency (2018)',
          item15: 'Legal team for the Leadership of the Regional Representative Council of the Republic of Indonesia (2018)',
          item16: 'Legal team for Swiss German University, South Tangerang (2015)',
          item17: 'Legal team in several regional head election and legislative election cases at the Constitutional Court (2012 - 2017)',
        }
      }
    },

    Direktur: {
      titleDirektur: 'Board of Directors',
      direkturutama: 'Chief Executive Officer',
      direktur: 'Director',
      modal: {
        title: 'Biodata',
        nameLabel: 'Name',
        nameValue: 'Iwan Daru Sukmana',
        birthLabel: 'Place, Date of Birth',
        birthValue: 'Yogyakarta, January 27, 1978',
        eduLabel: 'Education',
        education: {
          item1: 'Master of Management, Prasetya Mulya University (currently enrolled)',
          item2: 'Chemical Engineering (Professional), Bandung Institute of Technology (2023))',
          item3: 'Bachelor of Chemical Engineering, Gadjah Mada University (2023)'
        },
        expLabel: 'Experience',
        experience: {
          item1:'Acting President Director of PT Pupuk Indonesia Utilitas (March 5, 2026 - present)',
          item2:'President Director of PT Pupuk Indonesia Pangan (November 13 - March 5, 2026)',
          item3: 'SVP of Development at PT Pupuk Indonesia (Persero) (August 5, 2021 - November 12,2023)',
          item4: 'VP/Project Coordinator at PT Pupuk Indonesia (Persero) (November 1, 2017 - August 5, 2021)',
          item5: 'VP of Development at PT Pupuk Kujang (January 9, 2014 - October 31, 2017)'
        }
      },
      modal2: {
        titlefront: 'Chief Financial Officer',
        title: 'Biographical Data',
        nameLabel: 'Name',
        nameValue: 'Nuri Kristiawan',
        birthLabel: 'Place, Date of Birth',
        birthValue: 'Surabaya, January 27, 1971',
        eduLabel: 'Education',
        education: {
          item1:
            'Bachelor of Mathematics Education, Sanata Dharma University Yogyakarta (1996)'
        },
        expLabel: 'Experience',
        experience: {
          item1:
            'Finance Director of PT Pupuk Indonesia Utilitas (January 20, 2022 - Present)',
          item2: 'Chief Financial Officer, PT Gresik Cipta Sejahtera (2019–2021)',
          item3:
            'Chief Administration and Finance, Site Officer, PT Rekayasa Industri (2017–2019)',
          item4:
            'Chief Administration and Finance, Head Officer, PT Rekayasa Industri (2015–2017)',
          item5:
            'Administration and Finance, Head Officer, PT Rekayasa Industri (2009–2015)'
        }
      },
      modal3: {
        titlefront: 'Chief Operation Officer',
        title: 'Biographical Data',
        nameLabel: 'Name',
        nameValue: 'Anis Ernani',
        birthLabel: 'Place, Date of Birth',
        birthValue: 'Surabaya, January 10, 1968',
        eduLabel: 'Education',
        education: {
          item1:
            'Bachelor of Chemical Engineering, Sepuluh Nopember Institute of Technology (1991)',
          item2:
            'Master of Chemical Engineering, Sepuluh Nopember Institute of Technology (2007)'
        },
        expLabel: 'Experience',
        experience: {
          item1:
            'Director of Operations, PT Pupuk Indonesia Utilitas (January 20, 2022 - Present)',
          item2: 'President Director, Petrokimia Kayaku (2018-2021)',
          item3: 'GM of Technology, PT Petrokimia Gresik (2015-2017)',
          item4: 'GM of Development, PT Petrokimia Gresik (2014-2015)'
        }
      }
    },

    produk: {
      title: 'Gresik Gas Cogeneration Plant',
      description:
        'PT Pupuk Indonesia Utilitas (PI Utilitas), formerly known as PT Pupuk Indonesia Energi, was established based on Deed No. 11 dated August 18, 2014. In the same year, the construction of the Gresik Gas Cogeneration Plant (GGCP) in Gresik, East Java, was initiated. In 2015, PI Utilitas began the physical construction of the Gresik Gas Cogeneration Plant. In April 2018, the GGCP plant officially began commercial operations and continues to operate to this day.',
      description2:
        'The GGCP project, which began in 2018 and has been optimized, continues to drive PI Utilitas performance to excel in business competition without neglecting its responsibilities as a corporation that grows in the public eye. By prioritizing business practices that remain environmentally conscious, PI Utilitas is confident that it will continue to grow into a sustainable and highly ethical corporation.'
    },

    anakPerusahaan: {
      title: 'Kaltim Daya Mandiri',
      description: 'Kaltim Daya Mandiri (KDM) is a utility and energy company established with the aim of supplying utilities to the production and residential facilities of PT Pupuk Kaltim and other companies located in the Kaltim Industrial Estate.',
      description2: 'PT Kaltim Daya Mandiri (KDM), as a subsidiary of PT Pupuk Indonesia Utilitas, was established on September 14, 1995. Initially, KDM invested in 1 unit of 34 MW Gas Turbine Generator (GTG), then added 1 unit of 168 tons/hour Heat Recovery Steam Generator (HRSG) and 1 unit of 156 m³/h Demin Water Plant in 2000. In the following years, KDM built one 500 Nm³/h Nitrogen Plant, integrated 200 MVA of electricity, and one 2x50 m³/h SWRO unit. In 2008, KDM formed a subsidiary, PT KDM Argo Energy, and acquired renewable energy companies PT Banyumas Energy Lestari and PT Mitra Daya Kencana in 2015.',
      description3: 'KDMs main business is producing electricity, steam, demineralized water, nitrogen, and electrical integration services for the needs of the Pupuk Kaltim factory and companies in the industrial area.'
    },

    operasiPemeliharaan: {
      title: 'Operation & Maintenance',
      subtitle: 'Our Strategy',
      bodytitle: 'Providing comprehensive O&M services that ensure the availability, reliability, and efficiency of industrial energy & utility systems – through best-in-class services, predictive maintenance, and a team of operational experts.',
      leftTitle: 'Our Services',
      serviceBox: {
        box1: 'Power Plant (Gas, Coal, etc) Operation & Maintenance'
      }
    },
    perencanaanProyek: {
      title: 'Project development partnership',
      section1: {
        title: '1. Feasibility study & business case preparation',
        bullet1: 'Technical, financial, and regulatory assessment',
        bullet2: 'Market and demand analysis'
      },
      section2: {
        title: '2. Project structuring & investment modeling',
        bullet1: 'BOO, BOT, Leasing, etc.',
        bullet2: 'Risk allocation and revenue-sharing systems'
      },
      section3: {
        title: '3. Partner identification & consortium building',
        bullet1: 'Strategic alliances with technology providers, EPCs, and investors',
        bullet2: 'Involvement of industry and utility clients' 
      },
      section4: {
        title: '4. Financing & capital raising support',
        bullet1: 'Project financing arrangements (equity, debt, blended finance)',
        bullet2: 'Collaboration with banks and investors' 
      }
    },

    pengalamanKami: {
      title: 'Our Experience in SOLAR PV :',
      colum1: {
          bullet1: '8 kWp: Rooftop CRR GGCP Factory, Gresik'
      },
      colum2: {
          bullet1: '1,256 kWp: PKT Headquarters Rooftop, Bontang'
      },
      colum3: {
        bullet1: '12 kWp: Rooftop of GGCP Factory Workshop, Gresik',
        bullet2: '83 kWp: Rooftop of KDM Plant Site, Bontang',
      },
      colum4: {
        bullet1: '2,613 kWp: PKT Rooftop Workshop and Warehouse, Bontang',
      },
      colum5: {
        bullet1: '495 kWp: PT Pupuk Kujang Warehouse, Cikampek'
      }
    },


    tabs: {
      env_policy: 'Environmental Policy',
      hse_energy: 'Occupational Health, Safety, and Environment Policy & Energy Conservation',
      sustain_commitment: 'Sustainability Commitment',
      sustain_priority: 'Sustainability Priorities',
      csr: 'CSR Activities'
    },

    keberlanjutan: {
      title: 'Sustainable Development Goals',
      tab1: {
      title: 'Environmental Policy',
      desc: 'PT Pupuk Indonesia Utilitas is committed to conducting environmentally conscious operations by complying with regulations, reducing pollution impacts, and managing natural resources sustainably. We continue to improve our environmental performance through eFiciency, climate change mitigation, biodiversity conservation, and cooperation with local communities.' 
      },
      tab2: {
        title: 'Occupational Health, Safety, and Environment Policy & Energy Conservation',
        desc: 'PT Pupuk Indonesia Utilitas is committed to implementing a culture of Occupational Safety, Health, and Environment (K3LH) as well as Energy Conservation in all operational activities. We ensure that every activity is carried out safely, eFiciently, and in an environmentally friendly manner, while complying with applicable regulations to achieve sustainable performance and zero accidents.'
     },
     tab3: {
         title: 'Sustainability Commitment',
         desc: 'PT Pupuk Indonesia Utilitas is committed to implementing a culture of Occupational Safety, Health, and Environment (K3LH) as well as Energy Conservation in all operational activities. We ensure that every activity is carried out safely, eFiciently, and in an environmentally friendly manner, while complying with applicable regulations to achieve sustainable performance and zero accidents.'
     },
     tab4: {
         title: 'SDG Sustainability Priorities',
         subtitle1: 'Treevolution',
         desc1: 'A green revolution program to encourage massive tree planting as an eFort to support environmental sustainability and decarbonization programs.',
         subtitle2: 'PIU Academy',
         desc2: 'Capacity building activities for high school students in Jakarta with the Board of Directors of PT Pupuk Indonesia Utilitas in introducing Utilitas.',
         subtitle3: 'Development of Pecuk Indah Ecoriparian Tourism Village',
         desc3: 'Development of the Pecuk Indah Ecorparian Ecotourism Program Package. This activity produced several program outputs that can be implemented in tourist villages. Among others:',
         bullet1: 'Basic Ecotourism: River Tour and Tour Guide',
         bullet2: ' Spectacular Ecotourism: River Tour, Tour Guide, and Souvenirs (nipah syrup, tote bag, and key chain)'
     },
     tab5: {
         title: 'Corporate Social Responsibility',
         desc: 'As part of the companys social responsibility towards consumers, employees, shareholders, communities, and the environment in all aspects of the companys operations, PT Pupuk Indonesia Utilitas is committed to providing assistance and conducting social activities for the community, especially those located in the vicinity of the Companys operational areas.'
     }
    },
    

    portfolioEnergi: {
      title: 'Renewable Energy & Clean Energy Portfolio',
      titleRight: '“Promoting energy transition by investing in measurable, low-carbon, future-ready renewable energy assets to support industrial decarbonization and national sustainability goals.”',
      section1: {
        title: '1. Solar PV (PLTS)',
        bullet1: 'Ground mounted, Rooftop, etc.',
        bullet2: 'On-grid and Off-grid applications'
      },
      section2: {
        title: '2.Energy Storage System (ESS)',
        bullet1: 'Battery Energy Storage System (BESS) to support the power grid',
        bullet2: 'Solar and storage hybrid project'
      },
      section3: {
        title: '3. Project Development & Co-Investment',
        bullet1: 'BOO/BOT model with clients and IPPs',
        bullet2: 'Partnerships with developers or industrial estates'
      },
      section4: {
        title: '4. Research & Development in Green Energy',
        bullet1: 'Technology search for emerging clean energy solutions',
        bullet2: 'Collaboration with universities, research centers, and technology providers'
      },
    },


    expertiseStrategy: {
      title: 'Company Expertise & Strategy',
      leftTitle: 'Our Expertise',
      rightTitle: 'Core Company Strategy',
      expertiseItems: {
        skill1: 'Turbine Generator',
        skill2: 'Heat Recovery Steam Generator',
        skill3: 'Boiler',
        skill4: 'Water Treatment Plant',
        skill5: 'Wastewater Treatment Plant',
        skill6: 'Nitrogen & Oxygen Plant',
        skill7: 'Electricity Integration'
      },
      strategySteps: {
        item1: 'Developing a resilient and sustainable energy & utilities ecosystem through strategic investments in energy & utilities infrastructure',
        item2: 'Focusing on creating long-term value through strategic investments in energy and utility assets',
        item3: 'Empowering industries with measurable energy & utility solutions'
      }
    }
  }
}

// baca bahasa terakhir dari localStorage, kalau belum ada pakai 'id'
const savedLocale = localStorage.getItem('locale') || 'id'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages
})

export default i18n
